import React, {Component} from 'react'
import CashRegister from '../cashRegister/CashRegister'

class KktLeftColumn extends Component {
  render() {
    return <div className="tile is-12 is-child box">
      <p>Состав комплекта:</p>
      <p><span style={{fontWeight: 'bold', color: '#4fa800'}}>Выберите</span> ККТ</p>
      <ul style={{listStyle: 'none', marginLeft: '0'}}>
        <CashRegister register={this.props.register} handleRegisterSelect={this.props.handleRegisterSelect}/>
      </ul>
      {window.screen.width <= 1000 ? <p><strong>Информация и цена кассы ниже</strong></p>: null}
      <p>Дополнительно выбирают (установите «галочку»):</p>
      <ul style={{listStyle: 'none', marginLeft: '0'}}>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" checked={this.props.fiskal} onChange={this.props.changeFiskal} />
            Фискальный накопитель
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" checked={this.props.activationCode} onChange={this.props.changeActivationCode} />
            Код активации ККТ на услугу ОФД
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="signature" checked={this.props.signature} onChange={this.props.changeService} />
            Электронная подпись
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="abonent" checked={this.props.abonent} onChange={this.props.changeService} />
            Абонентское обслуживание на год при работе с ОФД (информационно-консультационное и техническое)
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="techicalLkFns" checked={this.props.techicalLkFns} onChange={this.props.changeService} />
            Техническая настройка ЛК ФНС
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="techicalLkOfd" checked={this.props.techicalLkOfd} onChange={this.props.changeService} />
            Техническая настройка ЛК ОФД
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="fiskalizationAndFNS" checked={this.props.fiskalizationAndFNS} onChange={this.props.changeService} />
            Фискализация ФН и постановка кассы на учет в ФНС
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="connectOfd" checked={this.props.connectOfd} onChange={this.props.changeService} />
            Подключение (активация) услуги ОФД
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="kktSoft" checked={this.props.kktSoft} onChange={this.props.changeService} />
            Программное обеспечение по управление ККТ
          </label>
        </li>
        <li style={{fontSize: '1.1rem'}}>
          <label className="checkbox">
            <input type="checkbox" name="delivery" checked={this.props.delivery} onChange={this.props.changeService} />
            Доставка
          </label>
        </li>
      </ul>
      <p><strong>Сделайте заказ прямо сейчас и получите скидку на Код активации в размере 1050 рублей !</strong></p>
    </div>
  }
}

export default KktLeftColumn


// WEBPACK FOOTER //
// ./src/components/ofdCalc/leftColumn/KktLeftColumn.js